import { Wizard } from "react-use-wizard";
import Content from "../Content";
import Footer from "../Footer";
import ImageWithCaption from "../ImageWithCaption";
import MetamaskAdd from "../assets/Metamask/Extension/Frame02.png";
import MetamaskTele from "../assets/Metamask/Extension/Frame02A.png";
import MetamaskRecovery from "../assets/Metamask/Extension/Frame03.png";
import MetamaskPassword from "../assets/Metamask/Extension/Frame03A.png";
import MetamaskRecoveryPhrase from "../assets/Metamask/Extension/Frame04.png";
import MetamaskRecoveryConfirm from "../assets/Metamask/Extension/Frame05.png";
import MetamaskSuccess from "../assets/Metamask/Extension/Frame06.png";

import ExtensionCard from "../ExtensionCard";
import { FlowStates } from "../../../pages/novice";
import { Dispatch, SetStateAction } from "react";

export type StepProps = {
  prevState: FlowStates | null;
  setFlowState: Dispatch<
    SetStateAction<{ prev: FlowStates | null; current: FlowStates }>
  >;
};

const MetamaskCreate: React.FC<StepProps> = ({ prevState, setFlowState }) => {
  return (
    <Wizard
      footer={
        <Footer
          prevState={prevState}
          setFlowState={setFlowState}
          currentState="metamaskCreate"
        />
      }>
      <Content title="Download the MetaMask plugin on Google Chrome, and open it.">
        <ExtensionCard wallet="mm" />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Select </span>
            <span className="text-coinage-blue">Create a Wallet.</span>
          </>
        }>
        <ImageWithCaption
          src={MetamaskAdd}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">
              When it asks if you want to help improve MetaMask, select{" "}
            </span>
            <span className="text-coinage-blue">No Thanks.</span>
          </>
        }>
        <ImageWithCaption
          src={MetamaskTele}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">
              Watch the video about your secret recovery phrase.
            </span>
          </>
        }
        description={
          <>
            Then, select{" "}
            <span className="text-coinage-blue font-bold">Next.</span>
          </>
        }>
        <ImageWithCaption
          src={MetamaskRecovery}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title="Create a password."
        description={
          <>
            Agree to the Terms of Use. Then, select{" "}
            <span className="text-coinage-blue font-bold">Create.</span>
          </>
        }>
        <ImageWithCaption
          src={MetamaskPassword}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title="MetaMask will generate a 12-word secret recovery phrase."
        description={
          <>
            <span className="text-coinage-orange font-bold">WAIT: </span>
            Write this down somewhere safe. Your 12-word recovery phrase is more
            important than your password. You will not be able to access your
            wallet without it, and it cannot be recovered.{" "}
            <>
              Then, select{" "}
              <span className="text-coinage-blue font-bold">Next.</span>
            </>
          </>
        }>
        <ImageWithCaption
          src={MetamaskRecoveryPhrase}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title="Confirm your recovery phrase by selecting the words in order."
        description={
          <>
            Then, select{" "}
            <span className="text-coinage-blue font-bold">Confirm.</span>
          </>
        }>
        <ImageWithCaption
          src={MetamaskRecoveryConfirm}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        showSuccessIcon
        title="Congratulations!"
        description="You made your first wallet!">
        <ImageWithCaption
          src={MetamaskSuccess}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
    </Wizard>
  );
};

export default MetamaskCreate;
